/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpTypeDisplay = "DEFAULT" | "NOT_LISTED" | "UNPURCHASABLE" | "%future added value";
export type PriceType = "%future added value" | "AUTOMATED_OFFER" | "NET" | "RETAIL" | "WEEKLY_SALE" | "%future added value";
export type PdpSharedDetailPayments_item = {
    readonly pdpTypeDisplay: PdpTypeDisplay | null;
    readonly pricing: {
        readonly prices: ReadonlyArray<{
            readonly type: PriceType | null;
            readonly status: string | null;
            readonly amount: {
                readonly convertedAmounts: {
                    readonly USD: number | null;
                } | null;
            } | null;
        } | null> | null;
    } | null;
    readonly " $refType": "PdpSharedDetailPayments_item";
};
export type PdpSharedDetailPayments_item$data = PdpSharedDetailPayments_item;
export type PdpSharedDetailPayments_item$key = {
    readonly " $data"?: PdpSharedDetailPayments_item$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedDetailPayments_item">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpSharedDetailPayments_item",
  "type": "Item",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "pdpTypeDisplay",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "pricing",
      "storageKey": null,
      "args": null,
      "concreteType": "ItemPricing",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "prices",
          "storageKey": null,
          "args": null,
          "concreteType": "Price",
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "type",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "status",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "amount",
              "storageKey": null,
              "args": null,
              "concreteType": "FinancialAmount",
              "plural": false,
              "selections": [
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "convertedAmounts",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "ConvertedAmounts",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "USD",
                      "args": null,
                      "storageKey": null
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};
(node as any).hash = '59e74955da74d57b0a555e793d6d15bd';
export default node;
